export default __webpack_public_path__ + "images/52fbfb43c0d71cb08e5feb35c0c9f8d1.png";